export const passingCriteriaApiHandler = {
  getOrganizationPassingCriteria: {
    method: "GET",
    path: () => `organizations-dashboard/passing-criteria`
  },
  updateOrganizationPassingCriteria: {
    method: "PUT",
    path: () => `organizations-dashboard/passing-criteria`
  }
};